import Head from "next/head";
import { connect } from "react-redux";

import { getStores } from "@store/stores/actions";
import InStoreConsumerCreditContainer from "@containers/FinancingSolutions/InStoreCredit";
import ErrorPage from "@containers/ErrorPage";

const InStoreCredit = ({ stores }) => {
  if (stores) {
    return (
      <>
        <Head>
          <title>Credit de consum</title>
        </Head>

        <InStoreConsumerCreditContainer />
      </>
    );
  } else {
    return <ErrorPage>Pagina nu este disponibila in acest moment.</ErrorPage>;
  }
};

InStoreCredit.pageLayout = "default";

InStoreCredit.getInitialProps = async (ctx) => {
  const { reduxStore } = ctx;

  const stores = reduxStore.getState().stores.data;
  const promises = [];

  if (!stores) promises.push(reduxStore.dispatch(getStores()));

  await Promise.all(promises);
};

export default connect((state) => ({
  stores: state.stores.data,
}))(InStoreCredit);
